<script setup lang="ts">
	import { BadgeVariant } from '../interfaces/roomBadge'

	interface Props {
		variant: BadgeVariant
	}

	defineProps<Props>()

	const badgeConfig: Record<
		BadgeVariant,
		{
			gradient: string
			icon: string
			label: string
			zIndex: string
		}
	> = {
		'best-price': {
			gradient:
				'bg-gradient-to-r from-emerald-500 via-emerald-600 to-green-600',
			icon: 'star',
			label: 'Mejor Precio',
			zIndex: 'z-50',
		},
		deposit: {
			gradient: 'bg-gradient-to-r from-amber-500 to-orange-500',
			icon: 'payments',
			label: 'Pago inmediato',
			zIndex: 'z-10',
		},
		international: {
			gradient: 'bg-gradient-to-r from-indigo-500 to-purple-600',
			icon: 'public',
			label: 'Tarifa internacional',
			zIndex: 'z-10',
		},
	}
</script>

<template>
	<div
		:class="[
			'shrink-0',
			badgeConfig[variant].zIndex,
		]"
	>
		<div
			:class="[
				'flex items-center gap-1.5 rounded-b-lg px-2.5 py-1 shadow-md',
				badgeConfig[variant].gradient,
			]"
		>
			<span class="material-symbols-outlined text-sm text-white">
				{{ badgeConfig[variant].icon }}
			</span>
			<span
				:class="[
					'text-xs text-white',
					variant === 'best-price' ?
						'font-bold tracking-wide'
					:	'font-semibold',
				]"
			>
				{{ badgeConfig[variant].label }}
			</span>
		</div>
	</div>
</template>
